import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
    nb: {
        header: 'Velkommen til Mattilsynets skjematjenester',
        infotext: `Du blir nå sendt videre til innloggingssidene til ID-porten.
        Etter at du har logget inn blir
        du styrt videre til Mattilsynets skjematjenester.`,
        first: {
            header: 'Første gang?',
            info: 'Hvis det er første gang du skal bruke Mattilsynets skjematjenester, anbefaler vi at du går til disse sidene først: '
        }
    }
})
